import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import {
  Box,
  Chip,
  Fab,
  Dialog,
  DialogTitle,
  Divider,
  Grid,
  Slider,
  Stack,
  Tooltip,
} from "@mui/material";
import { Collections, RestartAlt, Send } from "@mui/icons-material";
import p5 from "p5";
import { AppSingleton } from "../services/user_config";
import { sendFaiChunAPI } from "../services/backend";
import { dist, lerp, map, round } from "../utils/P5Utils";
import { LoadingButton } from "@mui/lab";
// import ScrollLock, { TouchScrollable } from "react-scrolllock";

const appSingleton = new AppSingleton();
let brushSize = 15;
// const uploadImage = ({ dataURL }) => {
//   appSingleton.socket.emit("fai_chun_upload", dataURL); // Replace 'message' with the actual event name and provide the message content
// };

const sketch =
  ({ image_uri, faiChunSize }) =>
  (p) => {
    let backgroundImage;
    // brushSize simply is the thikness of the brush stroke
    // let brushSize = 15;
    let f = 0.5;
    let spring = 0.4;
    let friction = 0.45;
    let v = 0.5;
    let r = 0;
    let vx = 0;
    let vy = 0;
    let splitNum = 100;
    let diff = 2;

    p.preload = () => {
      backgroundImage = p.loadImage(image_uri);
    };

    p.setup = () => {
      // console.log(
      //   `creating fai chun size, width: ${faiChunSize.width}, height: ${faiChunSize.height}`
      // );
      // p.pixelDensity(1);
      p.createCanvas(
        Math.floor(faiChunSize.width),
        Math.floor(faiChunSize.height)
      );
      p.background(backgroundImage);
      // p.createCanvas(1000, 1000);
    };

    p.draw = () => {
      if (p.mouseIsPressed) {
        if (!f) {
          f = true;
          p.x = p.mouseX;
          p.y = p.mouseY;
        }
        vx += (p.mouseX - p.x) * spring;
        vy += (p.mouseY - p.y) * spring;
        vx *= friction;
        vy *= friction;

        v += Math.sqrt(vx * vx + vy * vy) - v;
        v *= 0.55;

        p.oldR = r;
        r = brushSize - v;
        var num = Math.random(0.1, 1);
        for (let i = 0; i < splitNum; ++i) {
          p.oldX = p.x;
          p.oldY = p.y;
          p.x += vx / splitNum;
          p.y += vy / splitNum;
          p.oldR += (r - p.oldR) / splitNum;
          if (p.oldR < 1) {
            p.oldR = 1;
          }
          p.strokeWeight(p.oldR + diff); // AMEND: oldR -> oldR+diff
          p.line(
            p.x + Math.random(0, 2),
            p.y + Math.random(0, 2),
            p.oldX + Math.random(0, 2),
            p.oldY + Math.random(0, 2)
          );
          p.strokeWeight(p.oldR); // ADD
          p.line(
            p.x + diff * Math.random(0.1, 2),
            p.y + diff * Math.random(0.1, 2),
            p.oldX + diff * Math.random(0.1, 2),
            p.oldY + diff * Math.random(0.1, 2)
          ); // ADD
          p.line(
            p.x - diff * Math.random(0.1, 2),
            p.y - diff * Math.random(0.1, 2),
            p.oldX - diff * Math.random(0.1, 2),
            p.oldY - diff * Math.random(0.1, 2)
          ); // ADD
        }
      } else if (f) {
        vx = vy = 0;
        f = false;
      }
    };
  };

const NewFaiChunPage = () => {
  const { roomId } = useParams();
  const canvasRef = useRef(null);
  let faiChunMargin = 60;
  const [sliderBrushSize, setSliderBrushSize] = useState(15);
  const [faiChunSize, setFaiChunSize] = useState({
    // width: 105 * 2,
    // height: 297 * 2,
    width: Math.min(
      ((appSingleton.windowSize.height -
        faiChunMargin -
        appSingleton.topBarHeight) *
        105) /
        297,
      appSingleton.windowSize.width
    ),
    height:
      appSingleton.windowSize.height -
      faiChunMargin -
      appSingleton.topBarHeight, // MARK: height: 297 * 2; width: 105 * 2
  });
  // const [imgSrc, setImgSrc] = useState("/fai-chun/wish_animation/001.png");
  const [isSendingWishes, setIsSendingWishes] = useState(false);
  const [isFaiChunSelectionDialog, setIsFaiChunSelectionDialog] =
    useState(false);
  const pRef = useRef(null);
  const [currentFaiChunTemplate, setCurrentFaiChunTemplate] = useState({
    uri: "/fai-chun/templates/fai-chun-template.png",
    name: "fai-chun-template",
  });
  const [faiChunTemplates, setFaiChunTemplates] = useState([
    {
      uri: "/fai-chun/templates/fai-chun-template.png",
      name: "fai-chun-template",
    },
    { uri: "/fai-chun/templates/新春快樂.png", name: "新春快樂" },
    { uri: "/fai-chun/templates/年年有餘.png", name: "年年有餘" },
    { uri: "/fai-chun/templates/心想事成.png", name: "心想事成" },
    { uri: "/fai-chun/templates/萬事如意.png", name: "萬事如意" },
    { uri: "/fai-chun/templates/大吉大利.png", name: "大吉大利" },
    { uri: "/fai-chun/templates/步步高升.png", name: "步步高升" },
    { uri: "/fai-chun/templates/生意興隆.png", name: "生意興隆" },
    { uri: "/fai-chun/templates/身體健康.png", name: "身體健康" },
    { uri: "/fai-chun/templates/龍吟虎嘯.png", name: "龍吟虎嘯" },
    { uri: "/fai-chun/templates/龍馬精神.png", name: "龍馬精神" },
    { uri: "/fai-chun/templates/龍飛鳳舞.png", name: "龍飛鳳舞" },
    { uri: "/fai-chun/templates/生龍活虎.png", name: "生龍活虎" },
    { uri: "/fai-chun/templates/龍年大吉.png", name: "龍年大吉" },
    { uri: "/fai-chun/templates/龍年吉祥.png", name: "龍年吉祥" },
    { uri: "/fai-chun/templates/龍年賀喜.png", name: "龍年賀喜" },
    { uri: "/fai-chun/templates/龍來運轉.png", name: "龍來運轉" },
    { uri: "/fai-chun/templates/龍騰四海.png", name: "龍騰四海" },
    { uri: "/fai-chun/templates/猛龍過江.png", name: "猛龍過江" },
    { uri: "/fai-chun/templates/龍躍新程.png", name: "龍躍新程" },
    { uri: "/fai-chun/templates/龍騰虎躍.png", name: "龍騰虎躍" },
    { uri: "/fai-chun/templates/金龍報喜.png", name: "金龍報喜" },
    { uri: "/fai-chun/templates/金龍迎春.png", name: "金龍迎春" },
    { uri: "/fai-chun/templates/臥虎藏龍.png", name: "臥虎藏龍" },
    { uri: "/fai-chun/templates/飛龍在天.png", name: "飛龍在天" },
  ]);

  useEffect(() => {}, []);

  useEffect(() => {
    brushSize = sliderBrushSize;
  }, [sliderBrushSize]);

  const redrawCanvas = ({ uri }) => {
    pRef.current?.remove();
    pRef.current = new p5(
      sketch({ image_uri: uri, faiChunSize }),
      canvasRef.current
    );
    canvasRef.current.addEventListener("mousedown", (event) =>
      event.preventDefault()
    );
    canvasRef.current.addEventListener("mousemove", (event) =>
      event.preventDefault()
    );
  };

  useEffect(() => {
    redrawCanvas({ uri: currentFaiChunTemplate.uri });
  }, [currentFaiChunTemplate]);

  const sendFaiChun = ({ canvasRef }) => {
    const canvas = canvasRef.current.firstChild;
    const dataURL = canvas.toDataURL("image/png");
    // uploadImage({ dataURL });
    return new Promise((resolve, reject) => {
      sendFaiChunAPI({ roomId, dataURL }).then((data) => {
        const result = data?.data?.result;
        console.log(result);
        resolve();
      });
    });
  };

  return (
    <Box
      sx={
        {
          // position: "absolute",
          // width: "100%",
          // height: "100vh",
          // ml: -1,
          // mr: -1,
          // backgroundImage: 'url("/fai-chun/background/background-image.jpg")',
          // backgroundSize: "cover",
          // backgroundPosition: "center",
        }
      }
    >
      <Box
        sx={{
          position: "absolute",
          // width: "100%",
          height: "100vh",
          // ml: -1,
          // mr: -1,
          backgroundImage: 'url("/fai-chun/background/background-image.jpg")',
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <Stack
        spacing={4}
        sx={{
          margin: 2,
          right: 0,
          display: "flex",
          alignItems: "flex-end",
          position: "absolute",
        }}
      >
        <Tooltip title="點擊複製房間編號">
          <Chip
            label={`房間編號: ${roomId}`}
            color="primary"
            onClick={() => {
              navigator.clipboard.writeText(roomId);
              appSingleton.setNotifications([
                ...appSingleton.notifications,
                {
                  data: `已複製房間編號: ${roomId}`,
                },
              ]);
            }}
          />
        </Tooltip>
        <Tooltip title="點擊自選揮春">
          <Fab color="white" onClick={() => setIsFaiChunSelectionDialog(true)}>
            <Collections />
          </Fab>
        </Tooltip>
        <Tooltip title="點擊重寫">
          <Fab
            color="white"
            onClick={() => redrawCanvas({ uri: currentFaiChunTemplate.uri })}
          >
            <RestartAlt />
          </Fab>
        </Tooltip>
        <Box sx={{ height: 300 }}>
          <Slider
            sx={{
              '& input[type="range"]': {
                WebkitAppearance: "slider-vertical",
              },
            }}
            // color="black"
            style={{ color: "black" }}
            orientation="vertical"
            value={sliderBrushSize}
            aria-label="Brush Size"
            valueLabelDisplay="auto"
            onChange={(evt, newValue) => setSliderBrushSize(newValue)}
            // onKeyDown={preventHorizontalKeyboardNavigation}
          />
        </Box>
      </Stack>
      <Stack
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "88vh",
        }}
      >
        {/* <ScrollLock> */}
        <div ref={canvasRef} />
        {/* </ScrollLock> */}
      </Stack>
      <Box
        sx={{
          position: "absolute",
          margin: 2,
          right: 0,
          bottom: 8,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <LoadingButton
          variant="contained"
          size="large"
          endIcon={<Send />}
          loading={isSendingWishes}
          onClick={(evt) => {
            // setImgSrc("/fai-chun/wish_animation/button.gif");
            setIsSendingWishes(true);
            setTimeout(() => {
              // setImgSrc("/fai-chun/wish_animation/001.png");
              sendFaiChun({ canvasRef }).finally(() => {
                setIsSendingWishes(false);
              });
            }, 2000);
          }}
        >
          許願
        </LoadingButton>
      </Box>
      {/* <Box
        sx={{
          position: "absolute",
          margin: 4,
          right: 4,
          bottom: 64,
        }}
      >
        <img
          src={imgSrc}
          width={faiChunSize.width / 3}
          height={faiChunMargin.width / 3}
          onClick={(evt) => {
            setImgSrc("/fai-chun/wish_animation/button.gif");
            // setImgSrc("/fai-chun/wish_animation/button-no-background.gif");
            setTimeout(() => {
              setImgSrc("/fai-chun/wish_animation/001.png");
              sendFaiChun({ canvasRef });
            }, 2000);
          }}
        />
      </Box> */}
      <Dialog
        open={isFaiChunSelectionDialog}
        onClose={() => setIsFaiChunSelectionDialog(false)}
        fullWidth
      >
        {
          <Box sx={{ m: 4 }}>
            <Box>
              <DialogTitle
                sx={{
                  position: "sticky",
                  top: 0,
                  left: 0,
                  p: 1,
                }}
              >
                選擇一款喜愛的揮春
              </DialogTitle>
              <Divider sx={{ mb: 2 }} />
              <Grid container direction="row" wrap="nowrap" columnSpacing={8}>
                {faiChunTemplates.map((_template, index) => (
                  <Grid
                    item
                    key={`_template ${index}`}
                    sx={{
                      flexGrow: 1,
                    }}
                    onClick={(evt) => {
                      setIsFaiChunSelectionDialog(false);
                      setCurrentFaiChunTemplate(_template);
                    }}
                  >
                    <img
                      src={_template.uri}
                      style={{
                        height: appSingleton.windowSize.height / 2,
                      }}
                    />
                    {/* <ImageListItemBar title={_template.name} /> */}
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Box>
        }
      </Dialog>
    </Box>
  );
};

export { NewFaiChunPage };
